import request from "react-rb/request"

/**
 * List the available plugin environments.
 *
 * @return {object[]} The plugin environments
 */
export async function listPluginEnvironments() {
  const response = await request("/plugins/environments.json", {
    method: "GET"
  })
  if (!response.ok) throw response
  return response.data
}

/**
 * Create a new plugin
 *
 * @return {object} The plugin
 */
export async function createPlugin({ appId, label, env }) {
  const response = await request(`/apps/${appId}/plugins`, {
    method: "POST",
    data: { label, env }
  })
  if (!response.ok) throw response
  return response.data.plugin
}

/**
 * Update a new plugin
 *
 * @return {object} The plugin
 */
export async function updatePlugin(pluginData) {
  const {
    id,
    label,
    description,
    icon_url,
    sort_order,
    request_url,
    settings,
    appId
  } = pluginData

  const response = await request(`/apps/${appId}/plugins/${id}`, {
    method: "PUT",
    data: {
      label,
      description,
      icon_url,
      sort_order,
      request_url,
      settings
    }
  })
  if (!response.ok) throw response
  return response.data.plugin
}

/**
 * List the available plugins.
 *
 * @param {object} [queryParams={}] - The query parameters for the request
 * @return {object[]} The list of plugins
 */
export async function listPlugins(queryParams = {}) {
  const params = new URLSearchParams(queryParams)
  const url = `/plugins${params.toString() ? `?${params}` : ""}`

  const response = await request(url, { method: "GET" })
  if (!response.ok) throw response

  return response.data
}
